// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"493":"34b23df1","666":"a78c030c"}[chunkId] + ".css";
};